import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CATEGORY_EDIT } from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import {
  allCategoriesSelector,
  allRoomsSelector,
  allRoomTypesSelector,
} from '../../../../property/propertySlice';
import './Category-View.scss';

const CategoryView = (props) => {
  const { category, onViewToggle, toggleDrawer, selectedHotel, permissions } = props;
  const [selectedCategory, setSelectedCategory] = useState(category);
  const originalCateogires = useSelector(allCategoriesSelector);
  const originalRoomTypes = useSelector(allRoomTypesSelector);
  const originalRooms = useSelector(allRoomsSelector);

  useEffect(() => {
    // retreiving selected category details from api
    const catObj = {
      ...originalCateogires.find((cat) => cat.id === category.id),
    };
    catObj['rooms'] = originalRooms.filter((room) => room.categoryId === catObj.id);
    catObj['roomTypes'] = originalRoomTypes.filter((room) => room.categoryId === catObj.id);

    setSelectedCategory(catObj);
  }, [selectedHotel, originalCateogires]);

  const onClickEdit = (event) => {
    toggleDrawer(CATEGORY_EDIT, true, selectedCategory);
  };

  const getRooms = (rooms) => {
    let roomList = rooms.map((room) => {
      return room.number;
    });
    return roomList.sort().join(', ');
  };

  const retrieveRoomTypes = (roomTypes) => {
    return roomTypes
      .map((tempRoomType) => {
        return tempRoomType.name;
      })
      .join(', ');
  };

  const renderScreen = () => {
    return (
      <>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12 mb-4'>
            <span className='page-title-secondary'>Details</span>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Category Name</div>
            <div className='details-value preview-breaks'>{selectedCategory.name}</div>
          </div>
          <div className='col-md-8'>
            <div className='details-label'>Category Code</div>
            <div className='details-value'>{selectedCategory.code}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>No.of Room types</div>
            <div className='details-value'>{selectedCategory.roomTypes?.length}</div>
          </div>
          <div className='col-md-8'>
            <div className='details-label'>Room Types</div>
            <div className='details-value'>
              {selectedCategory.roomTypes?.length
                ? retrieveRoomTypes(selectedCategory.roomTypes)
                : '---'}
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>No.of Rooms</div>
            <div className='details-value'>{selectedCategory.rooms?.length}</div>
          </div>
          <div className='col-md-8'>
            <div className='details-label'>Room Numbers</div>
            <div className='details-value'>
              {selectedCategory.rooms?.length ? getRooms(selectedCategory?.rooms) : '---'}
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {selectedCategory && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          title={selectedCategory.name}
          createdUserId={selectedCategory.createdBy}
          isEditable={
            permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
        />
      )}
    </>
  );
};

export default CategoryView;
